import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import ComponentServiceBenefitItem from './componentServiceBenefitItem.js';

/**
 * @typedef {import('../../App.d.ts').ServiceBenefitsProps} ServiceBenefitsProps
 */
/**
 * @param {ServiceBenefitsProps} props
 */
export default (props) => {
  return (
    <Container>
      <section
        data-testid="service-benefits"
        className="ebds-service-benefits"
      >
        {props.benefits.map((benefit, index) => (
          <ComponentServiceBenefitItem
            key={index}
            {...benefit}
          />
        ))}
      </section>
    </Container>
  );
};
